<template>
    <div class="memwrap modulewrap">
        <Cmember :curnavkv="curnavkv" :hassave="true" @save="saveprofile">
            <template v-if="isload">
                <div class="profile">
                    <dl><dt>{{$common.dicword('username',true)}}</dt><dd>{{me.username}}</dd></dl>
                    <dl>
                        <dt>{{$common.dicword('mobile',true)}}</dt>
                        <dd>
                            <router-link to="/member/mobile">
                                {{$common.markmobile($store.state.mymobile)||$common.dicword('bindmobile')}}
                            </router-link>
                        </dd>
                    </dl>
                    <dl><dt>{{$common.dicword('nickname',true)}}</dt><dd><el-input v-model="me.showname"></el-input></dd></dl>
                    <dl><dt>{{$common.dicword('birth',true)}}</dt><dd><el-date-picker type="date" v-model="me.birth" value-format="yyyy-MM-dd"></el-date-picker></dd></dl>
                    <dl>
                        <dt>{{$common.dicword('gender',true)}}</dt>
                        <dd>
                            <el-radio-group v-model="me.sex">
                                <el-radio-button :label="1">{{$common.dicword('male')}}</el-radio-button>
                                <el-radio-button :label="2">{{$common.dicword('female')}}</el-radio-button>
                            </el-radio-group>
                        </dd>
                    </dl>
                    <dl><dt>{{$common.dicword('address',true)}}</dt><dd><el-input v-model="me.addr"></el-input></dd></dl>
                    <dl v-if="schooltitle">
                        <dt>{{$common.dicword('school',true)}}</dt>
                        <dd>{{schooltitle}}</dd>
                    </dl>
                    <dl v-if="classtitle">
                        <dt>{{$common.dicword('infoclass',true)}}</dt>
                        <dd>{{classtitle}}</dd>
                    </dl>
                </div>
            </template>
        </Cmember>
    </div>
</template>
<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'profile',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 1,
                me: {},
                classtitle: '',
                schooltitle: ''
            };
        },
        methods: {
            getdata: function () {
                let jsondata = { 'postdata': { 'api': 'member', 'act': 'myprofile' } };
                this.$common.post(jsondata, res => {
                    res.infodata.birth = this.$common.basic.dateformat(res.infodata.birth);// || '2000-01-01';
                    this.me = res.infodata || {};
                    this.schooltitle = this.$common.basic.mydecode(res.schooltitle);
                    this.classtitle = this.$common.basic.mydecode(res.classtitle);
                    this.isload = true;
                });
            },
            saveprofile: function () {
                let jsondata = { 'postdata': { 'api': 'member', 'act': 'myprofilesave', 'data': this.me } };
                this.$common.post(jsondata, () => {
                    let showname = this.me.showname || this.me.username;

                    this.$store.dispatch('setshowname', showname);
                });
            }
        },
        mounted() {
            this.getdata();
        }
    }
</script>
